<template>
  <time datetime="time">
    {{ humanized }}
    <q-tooltip>
      {{ fullTime }}
    </q-tooltip>
  </time>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    time: String,
  },
  data() {
    return {
      timerId: null,
      humanized: null,
    };
  },
  computed: {
    fullTime() {
      return moment(this.time).format('MMM D YYYY, h:mma');
    },
  },
  methods: {
    update() {
      this.humanized = moment(this.time).fromNow();
    },
  },
  created() {
    this.update();
    this.timerId = setInterval(this.update, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timerId);
  },
};
</script>
